import {
  CreateInventoryAuditRequest,
  FilterInventoryAuditRequest,
  InventoryAuditDetailModel,
  InventoryAuditModel,
} from "../../../infrastructure/model/InventoryAuditModel";
import InventoryAuditService from "../../../infrastructure/services/InventoryAuditService";
import { PageResponse } from "../../constants/AppTypes";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const getInventoryAuditUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: FilterInventoryAuditRequest;
  },
): Promise<PageResponse<InventoryAuditModel[]>> => {
  const { setLoading, showError, request } = deps;
  try {
    setLoading?.(true);
    let dataMapper: PageResponse<InventoryAuditModel[]> = {
      data: [],
      total: 0,
    };
    const res = await InventoryAuditService.getInventoryAudit(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = {
          data: res.data.data,
          total: res.data.total,
        };
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const getSummaryInventoryAuditUseCase = async (
  deps: BaseCommonApiUseCaseDeps,
): Promise<InventoryAuditModel[]> => {
  const { setLoading, showError } = deps;
  try {
    setLoading?.(true);
    let dataMapper: InventoryAuditModel[] = [];
    const res = await InventoryAuditService.getSummaryInventoryAudit();
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const getInventoryAuditDetailUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    auditId: number;
  },
): Promise<InventoryAuditDetailModel[]> => {
  const { setLoading, showError, auditId } = deps;
  try {
    setLoading?.(true);
    let dataMapper: InventoryAuditDetailModel[] = [];
    const res = await InventoryAuditService.getInventoryAuditDetails(auditId);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const createInventoryAuditUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: CreateInventoryAuditRequest;
  },
): Promise<InventoryAuditModel | undefined> => {
  const { request, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper: InventoryAuditModel | undefined = undefined;
    const res = await InventoryAuditService.createImportInventoryAudit(request);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        showSuccess?.();
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};

export const deleteInventoryAuditUseCase = async (
  deps: BaseCommonApiUseCaseDeps & { id: number },
): Promise<boolean> => {
  const { id, setLoading, showError, showSuccess } = deps;
  try {
    setLoading?.(true);
    let dataMapper = false;
    const res = await InventoryAuditService.deleteInventoryAudit(id);

    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccess() {
        showSuccess?.();
        dataMapper = true;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
